interface Option {
    value: string;
    name: string;
}

interface SelectProps {
    name: string;
    value: string;
    options: Option[];
    onChange: (v: string | null) => void;
}

export default function Select({ name, value, options, onChange }: SelectProps) {
    return (
        <select
            key={value}
            className="filter-place--select filter-place--select-m"
            value={value}
            onChange={(e) => onChange(e.target.value)}
        >
            <option value="">{name}</option>
            {options.map((o) => (
                <option value={o.value}>{o.name}</option>
            ))}
        </select>
    );
}
